<template>
  <BriefStep :title="title" :tooltip="tooltip">
    <template v-slot:content>
      <div class="brief-form">
        <div class="uk-grid uk-child-width-1-2@m">
          <div
            class="form__input-wrapper form__input-wrapper--sufix"
            :class="{ error: $v.form.budgetFrom.$invalid }"
          >
            <label for="budgetFrom" class="form__label">Od: *</label>
            <input
              class="form-input"
              id="budgetFrom"
              type="text"
              name="budgetFrom"
              v-number="numberMask"
              v-model.trim="form.budgetFrom"
              @input="delayTouch($v.form.budgetFrom)"
            />
            <span class="form__input-sufix">zł</span>
            <span class="form__error-message">
              <template v-if="!$v.form.budgetFrom.bigger">
                {{ validationMessage.valueLow }}</template
              >
            </span>
          </div>
          <div
            class="form__input-wrapper form__input-wrapper--sufix"
            :class="{ error: $v.form.budgetTo.$invalid }"
          >
            <label for="budgetTo" class="form__label">Do: *</label>
            <input
              class="form-input"
              id="budgetTo"
              type="text"
              name="budgetTo"
              v-number="numberMask"
              v-model.trim="form.budgetTo"
              @input="delayTouch($v.form.budgetTo)"
            />
            <span class="form__input-sufix">zł</span>
            <span class="form__error-message">
              <template v-if="!$v.form.budgetTo.bigger">
                {{ validationMessage.valueToLow }}</template
              >
            </span>
          </div>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';
import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'Budget',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      // eslint-disable-next-line operator-linebreak
      'Za pieniądze szczęścia nie kupisz, ale nasz projekt jak najbardziej! Określ, ' +
      'jakim budżetem dysponujesz na tę realizację.',
    tooltip:
      // eslint-disable-next-line operator-linebreak
      'Wszystkie projekty wyceniamy indywidualnie, ale zdradzimy Ci, że cena za ' +
      // eslint-disable-next-line operator-linebreak
      'stronę internetową zaczyna się od 14999PLN, a za sklep od 15999PLN. ' +
      'Dolicz do tego podatek VAT.',
    form: {
      budgetFrom: '14999',
      budgetTo: '499999',
    },
    numberMask: {
      decimal: ',',
      separator: ' ',
      precision: 0,
      masked: false, /* doesn't work with directive */
    },
  }),
  computed: {
    minValue() {
      return Number(this.form.budgetFrom) + 1;
    },
  },
  validations() {
    return {
      form: {
        budgetFrom: {
          required,
          bigger: () => Number(this.form.budgetFrom.replaceAll(' ', '')) >= 1,
        },
        budgetTo: {
          required,
          bigger: () => Number(this.form.budgetTo.replaceAll(' ', '')) > this.form.budgetFrom.replaceAll(' ', ''),
        },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.form__input-sufix {
  position: absolute;
  bottom: rem(19px);
  right: rem(10px);
}

</style>
